<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  name: 'PhoneFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'phone'
    };
  },

  methods: {
    getData() {
      return WarehouseDevicesService.getFilteredPhones({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
